import { ReactNode } from 'react';
import { SharedComponentsProps } from '../../../';

export const AlertAvailableVariant = [
  'error',
  'warning',
  'info',
  'success',
] as const;
export type AlertAvailableVariantType = typeof AlertAvailableVariant[number];

export type AlertProps = SharedComponentsProps & {
  /**
   * Content of the Alert
   */
  children?: ReactNode;
  /**
   * Type variant of the alert
   */
  typeVariant: AlertAvailableVariantType;
};

export type StyledAlertProps = {
  customStyle?: AlertProps['customStyle'];
};
